import React, { useState, useEffect, useRef } from "react";
import { Form, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Button from "@/common/elements/Button";
import DataTable from "@/common/elements/DataTable";
import CustomModal from "@/components/CustomModal";
import { StyledFlex, StyledSubTableContainer } from "@/common/styles";
import SecurityRulesRecordsForm from "@/pages/Security/Sections/SecurityRulesRecordsForm";
import {
  fetchSecurityRecords,
  fetchSecurityRecordById,
  createSecurityRecord,
  updateSecurityRecord,
  deleteSecurityRecord,
} from "@/apis/security/securityRulesRecordsApi";
import { clearCurrentRecord } from "@/slices/securityRulesRecordsSlice";
import { fetchAllSecurityListOfStaff } from "@/apis/staff/staffApi";
import { isNonEmptyVariable } from "@/util/common_function";
import { setBookings } from "@/slices/bookingsSlice";
import _ from "lodash";
import { v4 as uuidV4 } from "uuid";
import useDialog from "@/hooks/useDialog";

const UserInfoRulesControllingAccess = ({ staffGroupsId, bookingsFieldsEnabled = true }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const tableRef = useRef();
  const { bookings } = useSelector((s) => s?.bookings);
  const { showDialog } = useDialog();

  // const list = useSelector((s) => s.securityRulesRecords.list) || [];
  const [list, setList] = useState([])

  const loadingList = useSelector((s) => s.securityRulesRecords.listLoading);
  const record = useSelector((s) => s.securityRulesRecords.current);
  const recordLoading = useSelector((s) => s.securityRulesRecords.loading);
  const saving = useSelector((s) => s.securityRulesRecords.saving);
  const deleting = useSelector((s) => s.securityRulesRecords.deleting);

  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDeleteOpen, setDeleteOpen] = useState(false);
  const [mode, setMode] = useState("add");

  // useEffect(() => {
  //   // dispatch(fetchSecurityRecords());
  //   // dispatch(clearCurrentRecord());
  //   setSelectedRow(null);
  // }, [dispatch]);
  useEffect(() => {
    if (isNonEmptyVariable(bookings?.securityRulesRecords)) {
      let allRules = bookings?.securityRulesRecords?.map((e, i) => {
        return {
          ...e,
          uuid: uuidV4(),
        }
      })
      console.log(allRules, "allRules")
      if (allRules?.length) {
        setList([...allRules])
      }
      else{
        setList([])
      }
    }
  }, [bookings]);
  const onRowClick = (row, index) => {
    setSelectedRow(row);
    if(index !== null && index !== undefined) {
      openEdit();
    }
  };

  const openAdd = () => {
    form.resetFields();
    dispatch(clearCurrentRecord());
    setMode("add");
    setModalOpen(true);
  };

  const openEdit = () => {
    if (!selectedRow) return;
    dispatch(clearCurrentRecord());
    dispatch(fetchSecurityRecordById(selectedRow.securityRulesRecordsID));
    setMode("edit");
    setModalOpen(true);
  };

  const openDelete = () => {
    if (!selectedRow) return;
    // setDeleteOpen(true);
    showDialog("confirm", {
      title: "Are you sure you want to delete this record?",
      onConfirm: () => confirmDelete(),
      // onCancel: () => { setIsLoading(false) }
    });
  };

  const confirmDelete = () => {
    dispatch(deleteSecurityRecord(selectedRow.securityRulesRecordsID))
     let newList = _.cloneDeep(list)
     console.log({newList},"testNew")
         if (newList?.length) {
             newList = newList.filter((e, i) => {
               if (e.uuid != selectedRow?.uuid) {            
                 return e
               }
             })
             console.log({ newList },"testNew")
              dispatch(
           setBookings({
             securityRulesRecords: [...newList],
           })
         );
           }
    // setDeleteOpen(false);
    setSelectedRow(null);
  };

  const handleSave = () => form.submit();

  const onFinish = (values) => {
    const payload = {
      ...values,
      dateAdded: values.dateAdded?.format("MM/DD/YYYY"),
      timeAdded: values.timeAdded?.format("HH:mm"),
      staffId: bookings?.staffId,
      ruleActive: ruleActive ? "true" : "false"
    };
    let newList = _.cloneDeep(list)

    if (mode == "edit") {
      console.log({ selectedRow })
      if (newList?.length) {
        newList = newList.map((e, i) => {
          if (e.uuid == selectedRow?.uuid) {
            console.log({ ...e, ...payload }, "newList")
            return { ...e, ...payload }
          }
          return e
        })
        console.log({ newList })
      }
    }
    // console.log({ newList })

    if (mode == "add") {
      if (newList?.length == 0) {
        newList.push(payload)
        // setList([payload])
      } else {
        console.log({ payload })
        newList = [...newList, payload]
        // setList([...list, payload])
      }
    }
    dispatch(
      setBookings({
        securityRulesRecords: [...newList],
      })
    );
    setModalOpen(false);

  };

  const headers = [
    { key: "startingPoint", text: "Starting Point" },
    { key: "tableName", text: "Table Name" },
    { key: "fieldName", text: "Field Name" },
    { key: "recordID", text: "Record ID" },
    { key: "allowSetting", text: "Allow Setting" },
    { key: "denySetting", text: "Deny Setting" },
  ];
  const handleCancel = () => {
    setSelectedRow(null)
    tableRef.current.resetAll()
  }
  return (
    <>
      <StyledSubTableContainer marginTop="25px">
        <StyledFlex justify="space-between" align="center">
          <h2>Rules controlling access to particular records</h2>
          <StyledFlex gap="10px" marginBottom="5px" justify="end">
            <Button onClick={openAdd} loading={saving} disabled={!bookingsFieldsEnabled}>Add</Button>
            <Button onClick={openEdit} disabled={!selectedRow} loading={recordLoading}>Details</Button>
            <Button onClick={openDelete} disabled={!selectedRow || !bookingsFieldsEnabled} loading={deleting}>Delete</Button>
            <Button onClick={handleCancel} disabled={!selectedRow} loading={recordLoading}>Cancel</Button>
          </StyledFlex>
        </StyledFlex>

        <Spin spinning={loadingList}>
          <DataTable
            headers={headers}
            data={list || []}
            ref={tableRef}
            rowUniqueId="uuid"
            onRowClick={onRowClick}
            isAPiCallLoading={loadingList}
            autoResetSelection={false}
            selected={selectedRow === null}
          />
        </Spin>
      </StyledSubTableContainer>

      {isModalOpen && (
        <CustomModal
          size="lg"
          header="Security Rules Record"
          show={isModalOpen}
          onHide={() => setModalOpen(false)}
          onSaveClick={handleSave}
          confirmLoading={saving}
          backdrop={false}
          isDisabled={!bookingsFieldsEnabled}
        >
          <SecurityRulesRecordsForm
            form={form}
            initialValues={mode === "edit" ? selectedRow : {}}
            onFinish={onFinish}
            disabled={recordLoading || !bookingsFieldsEnabled}
          />
        </CustomModal>
      )}

      {isDeleteOpen && (
        <CustomModal
          size="md"
          header="Are you sure you want to delete this record?"
          show={isDeleteOpen}
          onHide={() => setDeleteOpen(false)}
          submitButtonText="Delete"
          onSaveClick={confirmDelete}
          confirmLoading={deleting}
          backdrop={false}
          isDisabled={!bookingsFieldsEnabled}
        >
        </CustomModal>
      )}
    </>
  );
};

export default UserInfoRulesControllingAccess;
